import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';

import { FormlyService, FormService } from '../../services';

@Component({
  selector: 'app-base-inline-form',
  templateUrl: './base-inline-form.component.html',
  styleUrl: './base-inline-form.component.scss',
})
export class BaseInlineFormComponent implements OnChanges {
  @Input() header: string;
  @Input() fields: FormlyFieldConfig[] = [];
  @Input() model: any = {};
  @Input() smallHeader = '';
  @Input() submitText = '';
  @Input() submitIcon = '';
  @Input() labelsVertical = false;
  @Input() leftHeader = false;
  @Input() fullWidth = false;
  @Input() marginBottom = true;
  @Input() marginHeaderTop = true;
  @Output() modelUpdated = new EventEmitter<any>();
  @Output() submitted = new EventEmitter<any>();

  form: UntypedFormGroup = new UntypedFormGroup({});
  options: FormlyFormOptions = {};
  inlineFields: FormlyFieldConfig[];

  constructor(
    private formService: FormService,
    private formlyService: FormlyService,
  ) {}

  ngOnChanges() {
    if (!this.fields) {
      return this.fields;
    }

    const fields = [...this.fields];
    if (this.submitText) {
      fields.push(
        this.formlyService.button(this.submitText, () => this.onSubmit(), {
          btnClass: 'primary',
          iconClass: this.submitIcon ? `fa fa-${this.submitIcon}` : undefined,
        }),
      );
    }

    fields.forEach((field: FormlyFieldConfig) => {
      field.wrappers = ['inline'];
      if (!this.labelsVertical && field.props) {
        field.props.horizontal = true;
      }
      return field;
    });

    this.inlineFields = fields;
  }

  onSubmit() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.formService.scrollToFirstInvalidField();
      return;
    }

    this.submitted.emit(this.model);
  }

  update() {
    this.updateModel({});
  }

  updateModel(model: any, markUpdated = false, markUnchanged = false) {
    this.model = { ...this.model, ...model };
    this.modelUpdated.emit(this.model);
    if (markUpdated) {
      this.form.markAsDirty();
      this.form.markAllAsTouched();
    }
    if (markUnchanged) {
      this.form.markAsPristine();
      this.form.markAsUntouched();
    }
  }
}
